/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery, useMutation } from "@apollo/client";
import classes from './profileInfo.module.scss';
import { GET_USERPROFILE_DATA } from "../../../graphQL/queries";
import ComponentMap from "../../../atom/componentMap";
import { SEND_EMAIL, UPADATE_USER_PROFILE } from "../../../graphQL/mutations";
import showMessage from "../Common/notification";
import axios from "axios";
import GeneralModal from "../Common/generalModal";
import { EditSvg, LeftArrowSvg } from "../../../constants/resources";
import { getENVData } from "../../../constants/constantValue";

const ProfileInfo = (props: any) => {
    const { setProfile } = props;
    const { user } = useAuth0();

    useEffect(() => {


    }, [user])

    const { data: UserProfile, refetch } = useQuery(GET_USERPROFILE_DATA, {
        variables: { email: user?.email },
    });

    const [UpdateData] = useMutation(UPADATE_USER_PROFILE, {
        variables: { id: UserProfile?.queryUserProfile[0]?.id },

        onError: (error) => {
        }
    })

    const [Email] = useMutation(SEND_EMAIL, {


        onError: (error) => {
        }
    })
    const [editMode, setEditMode] = useState(false);
    const [generalModal, setGeneralModal] = useState("false");

    console.log(UserProfile, 'UserProfile');


    const [data, setData] = useState<any>([]);

    useEffect(() => {
        setData([{
            name: 'firstName',
            title: 'Name',
            value: UserProfile?.queryUserProfile[0]?.firstName ? UserProfile?.queryUserProfile[0]?.firstName : '',
            placeholder: 'Write your first name',
            required: true,
            errormessage: 'Please enter First Name'
        },
        {
            name: 'lastName',
            title: 'Last name',
            value: UserProfile?.queryUserProfile[0]?.lastName ? UserProfile?.queryUserProfile[0]?.lastName : '',
            placeholder: 'Write your last name',
            hidden: true,
            errormessage: 'Please enter Last Name'
        },
        {
            name: 'email',
            title: 'Email address',
            type: 'email',
            value: UserProfile?.queryUserProfile[0]?.email ? UserProfile?.queryUserProfile[0]?.email : user?.email,
            placeholder: 'Write your email address',
            required: true,
            readOnly: true,
            errormessage: 'Please enter Email address',
        }, {
            name: 'phone',
            title: 'Number',
            type: "phoneNumber",
            value: UserProfile?.queryUserProfile[0]?.phone ? UserProfile?.queryUserProfile[0]?.phone : '',
            placeholder: 'XXXXXXXXXXXX',
            required: true,
            errormessage: 'Please enter Number'
        }
        ])
    }, [editMode])

    const SendRequest = () => {

        let flag = true;
        let variables: any = {};
        let errormessage = '';
        for (let i = 0; i < data.length; i++) {
            let node: any = data[i];
            if (node.required && node.required === true && (node.value === '' || node.value === undefined)) {
                errormessage = (errormessage === '') ? node.title : errormessage + ',<br/>' + node.title;
                flag = false;
            }
            let value = node.value;
            if (node.type === 'phoneNumber' && node.value !== '') {
                let value = node.value;

                if (value.length > 10 && value.length < 15) {
                    node.value = value;
                }
                else {
                    errormessage = (errormessage === '')
                        ? "Please enter a valid Phone Number"
                        : `${errormessage},<br/>Please enter a valid Phone Number`;

                    flag = false;
                }
            }
            if (node.type === 'email' && node.value !== '') {

                let value = node.value;
                let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (re.test(value)) {
                    node.value = value;
                }
                else {
                    errormessage = (errormessage === '')
                        ? "Please enter correct Email"
                        : `${errormessage},<br/>Please enter correct Email`;

                    flag = false;
                }
            }
            variables[node.name] = value;

        }

        if (flag) {
            if (UserProfile?.queryUserProfile.length > 0) {
                UpdateData({
                    variables: variables
                }).then((response: any) => {
                    if (response.errors === undefined) {
                        setGeneralModal("onlyClose")
                    } else {
                        showMessage("Error!", 'Please try again later', "danger")
                    }
                    setEditMode(false)
                    refetch()
                })
            }

        }
        else {
            showMessage("Fields are missing", errormessage, "danger")
        }
    }
    const ChangePassword = async (email: any) => {
        const env = getENVData();

        var options: any = {
            method: 'POST',
            url: `${env.base_url}/dbconnections/change_password`,
            headers: {
                'content-type': 'application/json',
            },
            data: {
                client_id: user?.aud,
                email: email,
                connection: 'Username-Password-Authentication'
            }
        };


        axios(options).then(function (response: any) {
            setGeneralModal("ChangePassword")
        }).catch(function (error: any) {
            console.error(error);
        });

    }
    const SendEmail = () => {
        Email({
            variables: {
                to: "info@familytc.com",
                // to: "sreehari@netstratum.com",
                subject: `${UserProfile?.queryUserProfile.length > 0 && UserProfile.queryUserProfile[0].firstName ? UserProfile.queryUserProfile[0].firstName : user?.nickname} wants to delete his account`,
                body: `<p>Please Contact</p>
                <p> ${UserProfile?.queryUserProfile.length > 0 && UserProfile.queryUserProfile[0].firstName ? UserProfile.queryUserProfile[0].firstName : user?.nickname}</p>
                <p>${UserProfile?.queryUserProfile.length > 0 && UserProfile.queryUserProfile[0].email ? UserProfile.queryUserProfile[0].email : user?.email}</p>
                <p>${UserProfile?.queryUserProfile.length > 0 && UserProfile.queryUserProfile[0].phone ? UserProfile.queryUserProfile[0].phone : ''}</p>`,
                submitTime: 1674655279
            }
        }).then((response: any) => {
            if (response.errors === undefined) {
                setGeneralModal("false")
            } else {
                showMessage("Error!", 'Please try again later', "danger")
            }
            setEditMode(false)
            refetch()
        })
    }
    return <div>
        <div onClick={() => editMode ? setEditMode(false) : setProfile('Main')} className={classes.flex}>
            <LeftArrowSvg />
            <div className={classes.backButton}>Back</div>
        </div>
        {editMode ? <div className={classes.noDataMain}>
            <div className={classes.noDataProfiles}>
                Personal information
            </div>
            <div className={classes.form}>
                {data.filter((node: any) => {
                    return node.hidden !== true
                }).map((node: any, key: any) => {
                    return <ComponentMap key={key} node={node} data={data} change={setData} />
                })}
                <div className={classes.buttonSets}>
                    <button className={classes.sendButton} onClick={() => SendRequest()}>Save</button>
                </div>
            </div>
        </div> :
            <div className={classes.ProfileMain}>
                <div className={classes.ProfileName}>
                    Personal information
                </div>
                <div className={classes.Profilesubhead}>
                    <div className={classes.head}>
                        <div className={classes.Profilename}>{UserProfile?.queryUserProfile.length > 0 && UserProfile.queryUserProfile[0].firstName ? UserProfile.queryUserProfile[0].firstName : user?.nickname}</div>
                        <div className={classes.ediButton} onClick={() => setEditMode(true)}>
                            <EditSvg />
                            Edit</div>
                    </div>
                    <div className={classes.datas}>
                        <div className={classes.details}>
                            <div className={classes.detailsName}>  Email: </div>
                            <div className={classes.detailsContent}>{UserProfile?.queryUserProfile.length > 0 && UserProfile.queryUserProfile[0].email ? UserProfile.queryUserProfile[0].email : user?.email}
                            </div>
                        </div>
                        {UserProfile?.queryUserProfile.length > 0 && UserProfile.queryUserProfile[0].phone ?
                            <div className={classes.details}>
                                <div className={classes.detailsName}>  Phone: </div>
                                <div className={classes.detailsContent}> {UserProfile.queryUserProfile[0].phone}
                                </div>
                            </div>
                            : null}
                        <div className={classes.details}>
                            <div className={classes.detailsName}>  Password: </div>
                            <div className={classes.detailsContent}>****
                            </div>
                        </div>
                        <div className={classes.buttonSet}>
                            <button className={classes.sendButton} onClick={() => ChangePassword(user?.email)}>Change Password</button>
                        </div>

                        <div className={classes.bottomSection}>
                            <div className={classes.logoutButton} onClick={() => setGeneralModal("signout")} > Sign out</div>
                            <div className={classes.DeleteAccount} onClick={() => setGeneralModal("remove")}> Request to delete account</div>
                        </div>
                    </div>
                </div>

            </div>
        }
        <div>
            {
                generalModal !== 'false' ? <GeneralModal message={generalModal === "signout" ? "Are you sure you want to sign out from your account?" : generalModal === "onlyClose" ? "Your personal information has been updated" : generalModal === "remove" ? "Are you sure you want to sign out from your account?" : "Please Check Your Email To Change Password"} keyword={generalModal === "signout" ? "Save" : generalModal === "remove" ? "Remove" : "Close"} setGeneralModal={setGeneralModal} SendEmail={SendEmail} /> : null
            }
        </div>
    </div >
}

export default ProfileInfo;